import { format, parseISO, isValid, parse } from 'date-fns'

export class Formatter {
  /**
   * Date format
   */
  static dateFormat: string = 'dd.MM.yyyy'
  static dateFormatLong: string = 'dd MMMM yyyy'
  static dateWithTimeFormat: string = 'dd.MM.yyyy HH:mm'
  static dateWithTimeSecondsFormat: string = 'dd.MM.yyyy HH:mm:ss'
  static timeFormat: string = 'HH:mm'
  static phoneFormat: string = '+# ### ###-##-##'
  static backendFormat = 'yyyy-MM-dd'

  static date(date: Date | string, formatString = this.dateFormat) {
    if (typeof date === 'string') {
      date = parseISO(date)
    }

    if (!isValid(date)) {
      console.warn(`In not valid date: ${date}`)
      return date
    }
    return format(date, formatString)
  }

  static parseDateString(date: string, formatString = this.backendFormat) {
    const parsed = parse(date, formatString, new Date())
    return isValid(parsed) ? parsed : null
  }

  static currencyFormat = {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }

  static currency(amount: number) {
    amount = parseFloat(String(amount)) || 0
    return amount.toLocaleString(
      'ru-RU',
      this.currencyFormat as Intl.NumberFormatOptions,
    )
  }

  static percent(amount: string | number) {
    amount = (parseFloat(String(amount))) || 0
    return amount.toLocaleString('ru-RU', {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    })
  }

  static phone(phoneNumber: string, pattern: string = this.phoneFormat) {
    let i = 0
    const v = phoneNumber.toString()
    return pattern.replace(/#/g, _ => v[i++])
  }
}
